import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});
@Injectable()
export class ManualSubscriptionService {
  ManualSubscriptionUrl = '/superadmin/rest/mgmt/account/license/invoice';
  ManualSubscriptionlistUrl = '/superadmin/rest/mgmt/account/license/invoice?bySystem-eq=false';
  countUrl = '/superadmin/rest/mgmt/consumer/count?';
  consumerAnalyticsCountUrl = '/superadmin/rest/mgmt/analytics/consumers/count?';
  proformaUrl = '/superadmin/rest/mgmt/proformainvoice'
  proformaInvoicesUrl = '/superadmin/rest/mgmt/proformainvoice?';
  proformaInvoiceCountUrl = '/superadmin/rest/mgmt/proformainvoice/count?';
  constructor(private http: HttpClient) { }
  createManualSubscription(formData) {
    return this.http.post(this.ManualSubscriptionUrl, formData, { headers: headers });
  }
  updateManualSubscription(formData, uuid) {
    return this.http.put(this.ManualSubscriptionUrl + '/' + uuid, formData, { headers: headers });
  }
  getstatment(filter, sortOrder,
    pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.ManualSubscriptionlistUrl + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getTotalFilterCount(filter: any): any {
    return this.http.get(this.ManualSubscriptionlistUrl + '/count?' + filter, { headers: headers });
  }
  getTotalStatementCount(filters) {
    return this.http.get(this.ManualSubscriptionlistUrl + filters, { headers: headers });
  }
  createProformaInvoice(formData) {
    return this.http.post(this.proformaUrl, formData, { headers: headers });
  }
  updateProformaInvoice(formData, uuid) {
    return this.http.put(this.proformaUrl + '/' + uuid, formData, { headers: headers });
  }
  getProformaInvoices(filter, sortOrder,
    pageNumber, pageSize): Observable<any> {
    return this.http.get(this.proformaInvoicesUrl + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getTotalProformaInvoicesCount(filter): Observable<any> {
    return this.http.get(this.proformaInvoiceCountUrl + filter, { headers: headers });
  }
   getProformInvoicDetails(uuid) {
    return this.http.get(this.proformaUrl +'/' + uuid, { headers: headers });
  }
   changeInvoiceStatus(uuid, status) {
   return this.http.put(this.proformaUrl + '/' + uuid + '/status/' + status, {headers: headers});
 }
}
